const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBirthdayHat4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 450.519,
    height: 604.725,
    viewBox: "0 0 119.2 160",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M169.762 168.285 110.83 38.595 50.562 167.67s1.691 18.028 62.059 18.633c51.455.514 57.141-18.018 57.141-18.018",
    style: {
      fill: "#94de4b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0303976
    },
    transform: "translate(-50.562 -26.314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.117 110.798-3.567 7.638 61.863 66.618a100.11 100.11 0 0 0 9.139-1.637l-67.435-72.62",
    style: {
      fill: "#f68121",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0303976
    },
    transform: "translate(-50.562 -26.314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.537 184.213c3.574.547 7.532 1.008 11.921 1.36L60.021 147.41l-3.566 7.64 27.082 29.163",
    style: {
      fill: "#9e7cdb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0303976
    },
    transform: "translate(-50.562 -26.314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.387 129.494-3.566 7.638 45.63 49.137a195.595 195.595 0 0 0 10.6-.063l-52.664-56.712",
    style: {
      fill: "#ee3264",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0303976
    },
    transform: "translate(-50.562 -26.314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167.544 163.406-10.318-22.707-62.472-67.676-3.574 7.656 76.364 82.727",
    style: {
      fill: "#ffda3e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0303976
    },
    transform: "translate(-50.562 -26.314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.11 52.986-3.6 7.708 40.868 45.13-10.658-23.456-26.61-29.382",
    style: {
      fill: "#35b1f0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0303976
    },
    transform: "translate(-50.562 -26.314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.386 175.6 85.846 92.1l-3.566 7.64 74.127 79.825c2.897-1.294 5.18-2.653 6.979-3.963",
    style: {
      fill: "#feb1b2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0303976
    },
    transform: "translate(-50.562 -26.314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.836 185.148c-14.082-1.475-23.245-4.162-29.205-6.993l4.967-12.182 16.94 18.24c2.273.348 4.701.663 7.298.935m.473-4.044-21.458-23.107 4.377-10.734 18.684 20.121-1.603 13.72m2.795-23.916L77.48 139.285l4.709-11.546 13.64 14.689-1.725 14.76m2.917-24.957-11.58-12.47 4.71-11.546 8.595 9.257-1.725 14.76m2.917-24.957-6.535-7.038 4.85-11.897 3.46 3.749-1.775 15.186m2.97-25.42-1.394-1.509 2.202-5.4-.807 6.91",
    style: {
      fill: "#cbefa7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0303976
    },
    transform: "translate(-50.562 -26.314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.83 142.428-13.641-14.689 3.253-7.978 11.579 12.47-1.192 10.197",
    style: {
      fill: "#fbc192",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0303976
    },
    transform: "translate(-50.562 -26.314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.836 185.148a154.864 154.864 0 0 1-7.299-.935l-16.939-18.24 3.253-7.976 21.458 23.107-.473 4.044",
    style: {
      fill: "#cfbfed",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0303976
    },
    transform: "translate(-50.562 -26.314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.912 167.384-18.684-20.12 3.252-7.98 16.624 17.904-1.192 10.196",
    style: {
      fill: "#f79bb3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0303976
    },
    transform: "translate(-50.562 -26.314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.713 92.089-3.46-3.749 3.261-7.994 1.395 1.51-1.196 10.233",
    style: {
      fill: "#ffeda0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0303976
    },
    transform: "translate(-50.562 -26.314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.746 117.472-8.596-9.257 3.253-7.978 6.535 7.038-1.192 10.197",
    style: {
      fill: "#ffd9d9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0303976
    },
    transform: "translate(-50.562 -26.314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.516 186.3h-.052.052m-.112 0-.08-.002.08.003m-.15-.003h-.049.05m-.122-.003h-.036.036m-.155 0h-.001",
    style: {
      fill: "#cdcfd1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0303976
    },
    transform: "translate(-50.562 -26.314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.713 186.314a269.394 269.394 0 0 1-.067-.003c2.222 0 4.355-.037 6.406-.105l-10.546-11.357c1.728-3.67 3.37-7.46 4.915-11.323l19.992 21.528a100.11 100.11 0 0 0 9.139-1.637l-26.049-28.052a238.5 238.5 0 0 0 4.008-12.303l33.896 36.502c2.897-1.294 5.18-2.653 6.979-3.963l-38.436-41.39a226.901 226.901 0 0 0 3.043-13.654l39.55 42.849 2.22 4.88s-5.525 18.028-55.05 18.028m-2.092-.01c-.036-.004-.07-.004-.105-.004H112.404l-.08-.003H112.205c-.024 0-.048 0-.072-.003h-.156a279.814 279.814 0 0 1-7.257-.183c.7-1.244 1.387-2.507 2.064-3.79l3.667 3.947c.717.013 1.435.026 2.17.034m44.605-45.603-27.616-29.917c.79-5.66 1.293-11.14 1.48-16.32l10.288 11.36 15.848 34.877",
    style: {
      fill: "#7bb547",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0303976
    },
    transform: "translate(-50.562 -26.314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.413 185.054-19.992-21.528a228.616 228.616 0 0 0 3.082-8.161l26.049 28.052a100.11 100.11 0 0 1-9.139 1.637",
    style: {
      fill: "#c66e21",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0303976
    },
    transform: "translate(-50.562 -26.314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.646 186.311c-.667 0-1.342-.003-2.025-.008-.735-.008-1.453-.02-2.17-.034l-3.667-3.947a180.562 180.562 0 0 0 3.722-7.473l10.546 11.357c-2.051.068-4.184.105-6.406.105",
    style: {
      fill: "#c0315a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0303976
    },
    transform: "translate(-50.562 -26.314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167.544 163.406-39.551-42.849c.628-3.303 1.169-6.569 1.617-9.775l27.616 29.917 10.318 22.707",
    style: {
      fill: "#cdb23d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0303976
    },
    transform: "translate(-50.562 -26.314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141.378 105.821-10.288-11.36c.148-4.078.1-7.972-.157-11.624l10.445 22.984",
    style: {
      fill: "#3293c5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0303976
    },
    transform: "translate(-50.562 -26.314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.407 179.564-33.896-36.502a239.412 239.412 0 0 0 2.44-8.85l38.435 41.389c-1.798 1.31-4.082 2.669-6.98 3.963",
    style: {
      fill: "#cc9396",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0303976
    },
    transform: "translate(-50.562 -26.314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.246 34.412c0-4.342 3.602-7.863 8.046-7.863 4.443 0 8.045 3.52 8.045 7.863s-3.602 7.866-8.045 7.866c-4.444 0-8.046-3.523-8.046-7.866",
    style: {
      fill: "#92bb65",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0261907
    },
    transform: "translate(-50.562 -26.314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.547 34.18a7.865 7.865 0 0 1 7.864-7.866 7.865 7.865 0 0 1 7.863 7.865 7.865 7.865 0 0 1-7.863 7.866 7.865 7.865 0 0 1-7.864-7.866",
    style: {
      fill: "#a0c468",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0261907
    },
    transform: "translate(-50.562 -26.314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.984 29.865c.6 1.111.94 2.381.94 3.733a7.863 7.863 0 0 1-14.436 4.314 7.865 7.865 0 1 0 13.496-8.047",
    style: {
      fill: "#b9d96c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0261907
    },
    transform: "translate(-50.562 -26.314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.192 30.101c0-.469-.043-.93-.12-1.378a7.844 7.844 0 0 0-5.661-2.41 7.865 7.865 0 0 0-7.66 9.64 7.963 7.963 0 0 0 5.446 2.145 7.996 7.996 0 0 0 7.995-7.997",
    style: {
      fill: "#b9d96c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0261907
    },
    transform: "translate(-50.562 -26.314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.53 28.05c-.368-.854-4.181-.59-5.71 1.404-1.53 1.988.793 3.638 2.178 1.886 1.386-1.755 4.238-1.647 3.531-3.29",
    style: {
      fill: "#cae9a4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0261907
    },
    transform: "translate(-50.562 -26.314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.246 34.412c0-4.342 3.602-7.863 8.046-7.863 4.443 0 8.045 3.52 8.045 7.863s-3.602 7.866-8.045 7.866c-4.444 0-8.046-3.523-8.046-7.866",
    style: {
      fill: "#ff3636",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0261907
    },
    transform: "translate(-50.562 -26.314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.547 34.18a7.865 7.865 0 0 1 7.864-7.866 7.865 7.865 0 0 1 7.863 7.865 7.865 7.865 0 0 1-7.863 7.866 7.865 7.865 0 0 1-7.864-7.866",
    style: {
      fill: "#ff4d4d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0261907
    },
    transform: "translate(-50.562 -26.314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.984 29.865c.6 1.111.94 2.381.94 3.733a7.863 7.863 0 0 1-14.436 4.314 7.865 7.865 0 1 0 13.496-8.047",
    style: {
      fill: "#ff886c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0261907
    },
    transform: "translate(-50.562 -26.314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.192 30.101c0-.469-.043-.93-.12-1.378a7.844 7.844 0 0 0-5.661-2.41 7.865 7.865 0 0 0-7.66 9.64 7.963 7.963 0 0 0 5.446 2.145 7.996 7.996 0 0 0 7.995-7.997",
    style: {
      fill: "#ff795f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0261907
    },
    transform: "translate(-50.562 -26.314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.53 28.05c-.368-.854-4.181-.59-5.71 1.404-1.53 1.988.793 3.638 2.178 1.886 1.386-1.755 4.238-1.647 3.531-3.29",
    style: {
      fill: "#ffc49c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0261907
    },
    transform: "translate(-50.562 -26.314)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthdayHat4);
export default __webpack_public_path__ + "static/media/birthday_hat_4.a8d780447c9d0b67f7b615f9934ef0a5.svg";
export { ForwardRef as ReactComponent };